<div class="rate-table-scroll">
  <div class="d-flex flex-row month-rate-table" role="table"
    [attr.aria-label]="'Selic rate and change by month for Brazil fiscal year ' + row.year">
    <div class="d-flex flex-column rate-col rate-col-bank">
      <span class="rate-head" role="columnheader">Bank</span>
      <span class="d-flex rate-subhead"><span>Rate</span><span>Change</span><span>Date</span></span>
      <span class="rate-cell bank-cell" role="rowheader">Central Bank of Brazil</span>
    </div>

    @for (month of months; track month.label) {
      <div class="d-flex flex-column rate-col" [class.extraordinary]="month.extraordinary">
        <span class="rate-head" role="columnheader">{{ month.label }}</span>
        <span class="d-flex rate-subhead">
          <span>Rate</span><span>Change</span><span>Date</span>
        </span>
        <span class="d-flex rate-cell" [class.changed]="month.change !== null && month.change !== 0" role="row">
          <span [class.blank]="month.rate === null" role="cell">{{ month.rate === null ? '—' : month.rate + '%' }}</span>
          <span role="cell" [class.increase]="month.change !== null && month.change > 0"
            [class.decrease]="month.change !== null && month.change < 0">{{ changeLabel(month.change) }}</span>
          <span class="date" role="cell">{{ month.date }}</span>
        </span>
      </div>
    }
  </div>
</div>
